import ServiceBase from "base/baseService"

export default class IsCstService extends ServiceBase {

    title = "CST do IS"
    pluralTitle = "CSTs do IS"
    url = '/cadastro/fiscal/iscst'
    frontUrl = '/cadastro/fiscal/iscst'
    frontUrlList = '/cadastro/fiscal/iscstlist'
    primaryKey = 'codigo_iscst'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Strings notNullable
        data.codigo_iscst = data?.codigo_iscst || ''
        data.descricao_iscst = data?.descricao_iscst || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
